// src/apiService.js

import axiosClient from './axiosClient'; // Import the Axios client

// Function to fetch vehicles
const getTourPackages = async () => {
    try {
        const response = await axiosClient.get('/tour-package'); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching vehicles:', error);
        throw error; // Rethrow the error for further handling
    }
};

const getTourPackageDetail = async (id) => {
    try {
        const response = await axiosClient.get(`/tour-package/${id}`); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching vehicles:', error);
        throw error; // Rethrow the error for further handling
    }
};

const createTourPackage = async (formData) => {
    try {
        const response = await axiosClient.post('/tour-package', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error creating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// DELETE vehicle by ID
const deleteTourPackage = async (id) => {
    try {
        const response = await axiosClient.delete(`/tour-package/${id}`);
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error deleting vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// PATCH vehicle by ID
const updateTourPackage = async (id, formData) => {
    try {
        const response = await axiosClient.patch(`/tour-package/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// Export the function
export { getTourPackages, deleteTourPackage, createTourPackage, updateTourPackage, getTourPackageDetail };
